export default __webpack_public_path__ + "static/color-applying-color-2-light-a07cc580d68893e5d93e4af6837bec9755c2ca08dbacd58be46d419269927e2f.png";